module.exports = __webpack_public_path__ + "img/gbt3745_1_g25-14.prt.47708eec.jpg";